<template>
  <div>
    <div
      style="display: flex; align-items: end"
      v-if="type == 'crops'"
      @click="handleCropType(cropType)"
    >
      <!-- <question-tab
                        :showDropdownQuestion="true"
                        :heading="crop.crop_type"
                      /> -->

      <input
        type="checkbox"
        style="transform: translateY(-16px); margin-right: 18px"
        @click="toggle()"
        :value="true"
        :checked="isChecked"
      />

      <p>
        {{ cropType.crop_type }}
        <span
          v-if="count"
          style="font-weight: 400; color: green; margin-left: 50px"
          >{{ count }} selected</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "headingDiv",
  props: {
    cropType: Object,
    type: String,
  },
  data() {
    return {
      selectedCropsType: [],
      count: null,
      isChecked: false,
      selectAll: [],
    };
  },
  created() {
    this.selectedCropsType =
      this.$store.getters["crmFilters/GET_SELECTED_CROPS_TYPE_ID"];
    const isAllChecked =
      this.$store.getters["crmFilters/GET_CROPS_FORMATTED_DATA"];
    isAllChecked.map((item) => {
      if (item.crop_type_id == this.cropType.crop_type_id)
        if (item.isAllSelect) {
          this.isChecked = item.isAllSelect;
        }
    });
    this.getCountOfDistricts();
  },
  watch: {
    "$store.state": {
      handler(newVal, oldVal) {
        console.log(" this.getCountOfDistricts();:", newVal, oldVal);
         this.getCountOfDistricts();
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    handleCropType(value) {
      console.log("crop", value);
      const CropDataFromStore =
        this.$store.getters["crmFilters/GET_SELECTED_CROPS_TYPE_ID"];

      if (!CropDataFromStore.includes(value.crop_type_id)) {
        CropDataFromStore.push(value.crop_type_id);
      } else {
        const indexofCropId = CropDataFromStore.indexOf(value.id);
        if (indexofCropId !== -1) {
          CropDataFromStore.splice(indexofCropId, 1);
          this.$store.dispatch("crmFilters/setCropsTyepId", CropDataFromStore);
        }
      }
      this.selectedCropsType =
        this.$store.getters["crmFilters/GET_SELECTED_CROPS_TYPE_ID"];
      this.getCountOfDistricts();
    },
    getCountOfDistricts() {
      const getCount =
        this.$store.getters["crmFilters/GET_CROPS_FORMATTED_DATA"];
      getCount.map((item) => {
        if (item.crop_type_id == this.cropType.crop_type_id) {
          this.count = item.crops.length;
        }
      });
    },
    toggle() {
      this.isChecked = !this.isChecked;
      const getData =
        this.$store.getters["crmFilters/GET_CROPS_FORMATTED_DATA"];
      let getCropsId = this.$store.getters["crmFilters/GET_CROPS_ID_DATA"];
      let allCropTypeSelected =
        this.$store.getters["crmFilters/GET_ALL_SELECTED_CROPS_TYPE_ID"];
      if (this.isChecked) {
         getData.map((item) => {
          if(item.crop_type_id == this.cropType.crop_type_id){
            if(item.crops.length!==0){
              item.crops=[]
            }
          }
         })
        getData.map((item) => {
          if (item.crop_type_id == this.cropType.crop_type_id) {
            item.isAllSelect = true;
            allCropTypeSelected.push(item.crop_type_id);
            this.cropType.crops.map((crop) => {
              item.crops.push(crop.id);
              getCropsId.push(crop.id);
            });
          }
        });
      } else {
        getData.map((item) => {
          if (item.crop_type_id == this.cropType.crop_type_id) {
            item.isAllSelect = false;
            item.crops = [];
            const index = allCropTypeSelected.indexOf(item.crop_type_id);
            if (index > -1) {
              allCropTypeSelected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
        });
        getCropsId = [];
        getData.map((item) => {
          if (item.isSelect || item.isAllSelect) {
            getCropsId.push(...item.crops);
          }
        });
      }
      const array = [1, 2, 3, 4, 2, 3, 5];
      getCropsId.reduce((accumulator, value) => {
        if (!accumulator.includes(value)) {
          accumulator.push(value);
        }
        return accumulator;
      }, []);
      this.$store.dispatch("crmFilters/setCropsFormatted", getData);
      this.$store.dispatch("crmFilters/setCropsId", getCropsId);
      this.$store.dispatch(
        "crmFilters/setIsAllCropsTypeIdSelected",
        allCropTypeSelected
      );
    },
  },
};
</script>
<style scoped>
.cropType {
  color: green !important;
}
input[type="checkbox"] {
  accent-color: #189d3b;
  height: 16px;
  width: 16px;
  border-radius: 4px;
}
</style>
